// Toast notification utility for eLaba SuperAdmin

export const showToast = (message, type = 'info', duration = 3000) => {
  // Remove existing toasts
  const existingToasts = document.querySelectorAll('.toast');
  existingToasts.forEach(toast => toast.remove());

  // Create new toast
  const toast = document.createElement('div');
  toast.className = `toast ${type}`;
  const iconColor = {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6'
  };

  toast.innerHTML = `
    <div style="display: flex; align-items: center;">
      <span style="margin-right: 10px; font-size: 18px; color: ${iconColor[type]}; font-weight: bold;">
        ${getToastIcon(type)}
      </span>
      <div>
        <div style="font-weight: 600; font-size: 14px; color: #1e293b;">
          ${getToastTitle(type)}
        </div>
        <div style="font-size: 14px; color: #64748b; margin-top: 2px;">
          ${message}
        </div>
      </div>
      <button onclick="this.parentElement.parentElement.remove()" 
              style="margin-left: 15px; background: none; border: none; font-size: 18px; cursor: pointer; color: #64748b;">
        ×
      </button>
    </div>
  `;

  // Add to DOM
  document.body.appendChild(toast);

  // Auto remove after duration
  setTimeout(() => {
    if (toast.parentElement) {
      toast.remove();
    }
  }, duration);
};

const getToastIcon = (type) => {
  const icons = {
    success: '●',
    error: '●',
    warning: '▲',
    info: '◆'
  };
  return icons[type] || icons.info;
};

const getToastTitle = (type) => {
  const titles = {
    success: 'Success!',
    error: 'Error!',
    warning: 'Warning!',
    info: 'Info'
  };
  return titles[type] || titles.info;
};

// Predefined toast functions
export const showSuccess = (message) => showToast(message, 'success');
export const showError = (message) => showToast(message, 'error');
export const showWarning = (message) => showToast(message, 'warning');
export const showInfo = (message) => showToast(message, 'info');